import type React from 'react';
import { useState } from 'react';
import { Form, Space, Input, Button, Radio, Select, DatePicker } from 'antd';

const { RangePicker } = DatePicker;
const { Option } = Select;

type LayoutType = Parameters<typeof Form>[0]['layout'];

export const ExampleFilter: React.VFC = () => {
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState<LayoutType>('horizontal');

  const onFormLayoutChange = ({ layout }: { layout: LayoutType }) => {
    setFormLayout(layout);
  };

  return (
    <Form form={form} initialValues={{ layout: formLayout }} layout="inline" onValuesChange={onFormLayoutChange}>
      <Space wrap direction="horizontal">
        <Form.Item label="Filter A" name="layout">
          <Radio.Group>
            <Radio.Button value="horizontal">Horizontal</Radio.Button>
            <Radio.Button value="vertical">Vertical</Radio.Button>
            <Radio.Button value="inline">Inline</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Filter B">
          <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item label="Fitler C">
          <Input placeholder="input placeholder" />
        </Form.Item>
        <Form.Item label="Fitler C">
          <Select defaultValue="lucy" style={{ width: 120 }}>
            <Option value="jack">Jack</Option>
            <Option value="lucy">Lucy</Option>
            <Option disabled value="disabled">
              Disabled
            </Option>
            <Option value="Yiminghe">yiminghe</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Fitler C">
          <RangePicker showTime />
        </Form.Item>

        <Button>Reset</Button>
        <Form.Item>
          <Button type="primary">Filter</Button>
        </Form.Item>
      </Space>
    </Form>
  );
};
